<template>
  <div class="set-education">
    <p class="who">你的学历</p>
    <div class="choose-con">
      <a class="content-btn" href="javascript:;" v-for="(item, index) in educationData" :key="index"
        :class="{'selected': education == item.key }" @touchstart="selectItem(item.key)"
        @touchend="skipStep()">{{item.value}}</a>
    </div>
    <p class="cautious">选择后不可更改哦，请谨慎选择</p>
  </div>
</template>

<script>
import { setCookie, getCookie } from '@/utils/tools'
export default {
  data () {
    return {
      education: null,
      educationData: [
        {
          key: 7,
          value: '博士'
        },
        {
          key: 6,
          value: '硕士'
        },
        {
          key: 5,
          value: '本科'
        },
        {
          key: 4,
          value: '大专'
        },
        {
          key: 8,
          value: '大专以下'
        }
      ]
    }
  },
  methods: {
    selectItem (val) {
      if (!val) return
      this.education = val
      setCookie('education', val)
    },
    skipStep () {
      this.$router.push({
        name: 'SetBirthday'
      })
    }
  },
  mounted () {
    let education = getCookie('education')
    if (education) {
      this.education = education
    }
  }
}
</script>
